import { render, staticRenderFns } from "./ModalAskRateKey.vue?vue&type=template&id=3c4a76a0&scoped=true&"
import script from "./ModalAskRateKey.vue?vue&type=script&lang=js&"
export * from "./ModalAskRateKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a76a0",
  null
  
)

export default component.exports